import axios from "axios";
import { IMoveReservationParameters, IParametersFreezing, IParametersSlot, IShipper } from "dataModels/settings";
import { 
    PARAMETERS_SLOT,
    PARAMETERS_FREEZING,
    POST_SHIPPER,
    GET_SHIPPER_LIST,
    MOVE_RESERVATION_PARAMS
} from "shared/constants";

//const HOST = process.env.REACT_APP_HOST_SETTINGS;
const HOST = window&&window._env_?window._env_.REACT_APP_HOST_SETTINGS:process.env.REACT_APP_HOST_SETTINGS;
const MODULE: string = "/settings";

export const getParametersSlot = () => {
    return axios.get(HOST + MODULE + PARAMETERS_SLOT)
        .then(response => {
            return response.data;
        })
}

export const putParametersSlot = (parametersData: IParametersSlot) => {
    return axios.put(HOST + MODULE + PARAMETERS_SLOT, parametersData)
        .then(response => {
            return response;
        })
}

export const getParametersFreezing = () => {
    return axios.get(HOST + MODULE + PARAMETERS_FREEZING)
        .then(response => {
            return response.data;
        })
}




export const putParametersFreezing = (parametersData: IParametersFreezing) => {
    return axios.put(HOST + MODULE + PARAMETERS_FREEZING, parametersData)
        .then(response => {
            return response;
        })
}

export const postShipper = (formData: IShipper) => {
    return axios.post(HOST + MODULE + POST_SHIPPER, formData)
        .then(response => {
            return response;
        })
}

export const getShipperList = () => {
    return axios.get(HOST + MODULE + GET_SHIPPER_LIST)
        .then(response => {
            return response.data;
        })
}

export const getMoveReservationParams = () => {
    return axios.get(HOST + MODULE + MOVE_RESERVATION_PARAMS)
        .then(response => {
            return response.data;
        })
}

export const postMoveReservationParams = (formData:IMoveReservationParameters) => {
    return axios.post(HOST + MODULE + MOVE_RESERVATION_PARAMS, formData)
        .then(response => {
            return response;
        })
}
